/* eslint-disable @typescript-eslint/no-non-null-assertion */
import ReactDOM from "react-dom/client";

import { Index } from ".";
const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<Index />);
